import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { SCDocumentacionModal } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModal";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { SCDocumentacionAceptadaModalCondicionado } from "./SCDocumentacionAceptadaModalCondicionado";
import ArticleIcon from "@mui/icons-material/Article";

export const CargarDocumentacionAprobadaCondicionado = ({
  folio,
  setLoader,
  loader,
  idproceso = 31,
  upload,
}) => {
  function capitalizar(cadena) {
    return cadena.charAt(0).toUpperCase() + cadena.slice(1).toLowerCase();
  }
  const [doctoselect, setDoctoSelect] = useState({
    iddocumento: "",
    documento: "",
  });

  const [data, setData] = useState({
    estado: {},
    detalle: [],
  });
  const [documentoselect, setDocumentoSelect] = useState({});

  useEffect(() => {
    onObtenerAnalisisDocumentacion();
  }, []);
  const onObtenerAnalisisDocumentacion = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `ACDocumentacion/CargarDocumentosAceptadosCondicionado?folio=${folio}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData({
          estado: result.estado,
          detalle: result.detalle,
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon className="wait" />;
      case "success":
        return <CheckCircleIcon className="success" />;
      case "warning":
        return <WarningIcon className="warning" />;
      case "error":
        return <ErrorIcon className="error" />;
      default:
        <></>;
    }
  };

  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          iddocumento
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const openModal = (documento, iddocumento) => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "block";
    setDocumentoSelect({
      documento,
      iddocumento,
    });
  };

  //Imprime el pedido Generado cuando aun no se a cargado las firmas
  const onImprimirPedidoMaquinaria = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoImpresion/ReportePDF?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  const onImprimirPagare = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Pagares/ImprimirPagare?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (result.length > 0) {
          result.forEach((documento, index) => {
            const linkSource = `data:application/pdf;base64, ${documento.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${documento.nombredocumento}-${index + 1}.${documento.extension
              }`; // Añade el número de documento al nombre del archivo
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
        } else {
          Swal.fire(
            "Clientes",
            "No se encontraron documentos para descargar",
            "info"
          );
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };
  return (
    <div className="analisis-solicitud-credito-proceso-condicionado-cargar-doc">
      <SCDocumentacionAceptadaModalCondicionado
        folio={folio}
        documento={documentoselect.documento}
        iddocumento={documentoselect.iddocumento}
        loader={loader}
        setLoader={setLoader}
        setdocumento={setDocumentoSelect}
        setdocumentos={onObtenerAnalisisDocumentacion}
        cargar={true}
        onObtenerAnalisisDocumentacion={onObtenerAnalisisDocumentacion}
        upload={upload}
      />
      <div className="analisis-solicitud-credito-proceso-condicionado-cargar-doc-container scroll-4">
        {data.detalle === undefined ||
          data.detalle === null ||
          data.detalle.length === 0 ? (
          <div></div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th></th>
                <th>Documento</th>
                <th>Comentarios</th>
                <th>Fecha Entrega</th>
                <th>Descargar</th>
                <th>Cargar</th>
              </tr>
            </thead>
            <tbody>
              {data.detalle !== undefined &&
                data.detalle !== null &&
                data.detalle.length > 0 &&
                data.detalle.map((item) => (
                  <tr>
                    <td
                      className={
                        item.enviar_revision ? "color-green" : "color-yellow"
                      }
                    >
                      <ArticleIcon />
                    </td>
                    <td>{capitalizar(item.documento)}</td>
                    <td>{item.comentarios}</td>
                    <td>
                      {item.habilitar === true &&
                        item.enviar_revision &&
                        item.tiene_documentacion === false && (
                          <div>{item.fecha_compromiso}</div>
                        )}
                    </td>
                    <td>
                      {item.tiene_documentacion === true && (
                        <div
                          onClick={() => onImprimirArchivo(item.iddocumento)}
                        >
                          <CloudDownloadIcon />
                          Descargar
                        </div>
                      )}
                    </td>
                    {item.estatus === "A" ? (
                      <td></td>
                    ) : item.estatus === "M" ?
                      (
                        <td>
                          <div
                            onClick={() =>
                              openModal(item.documento, item.iddocumento)
                            }
                          >
                            <CloudUploadIcon />
                            Modificar
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div
                            onClick={() =>
                              openModal(item.documento, item.iddocumento)
                            }
                          >
                            <CloudUploadIcon />
                            Cargar
                          </div>
                        </td>
                      )}

                  </tr>
                ))}
              {/* {data.documentacion.map((doc) => (
                <tr>
                  <td>{doc.documento}</td>
                  <td>
                    {doc.tiene_documentacion === true ? (
                      <div onClick={() => onImprimirArchivo(doc.iddocumento)}>
                        <CloudDownloadIcon />
                      </div>
                    ) : doc.iddocumento === 10 ? (
                      <div onClick={() => onImprimirPagare()}>
                        <CloudDownloadIcon />
                      </div>
                    ) : doc.iddocumento === 25 ? (
                      <div onClick={() => onImprimirPedidoMaquinaria()}>
                        <CloudDownloadIcon />
                      </div>
                    ) : (
                      <></>
                    )}
                  </td>
                  {doc.habilitar === false ? (
                    <td className="analianalisis-solicitud-credito-procesos-comentarios">
                      <OnGetIcon icon={doc.icono} />
                      {doc.comentarios}
                    </td>
                  ) : (
                    <td className="update-documento-analisis">
                      <div
                        onClick={() =>
                          openModal(doc.documento, doc.iddocumento)
                        }
                      >
                        <CloudUploadIcon />
                        Cargar
                      </div>
                    </td>
                  )}
                </tr>
              ))} */}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
